import { cva, type VariantProps } from 'class-variance-authority'
import * as React from 'react'
import { cn } from '@/lib/utils'

const chipVariants = cva(
  'inline-flex items-center border px-2 py-1 text-xs font-normal text-gray-10 transition-colors rounded',
  {
    variants: {
      variant: {
        default: 'border-gray-6 bg-gray-2 flex flex-row gap-1',
        secondary:
          'border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80',
        destructive:
          'border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/80',
        outline: 'text-foreground',
        nowrap: 'block whitespace-nowrap overflow-hidden text-ellipsis',
        gray: 'border-none bg-gray-3 text-gray-10 gap-2',
        success: 'bg-green-4 border-green-5',
        warning: 'bg-yellow-4 border-yellow-5',
        error: 'bg-red-4 border-red-5',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  },
)

export interface ChipProps
  extends React.HTMLAttributes<HTMLDivElement>, VariantProps<typeof chipVariants> {}

function Chip({ className, variant, ...props }: ChipProps) {
  return <div className={cn(chipVariants({ variant }), className)} {...props} />
}

export { Chip, chipVariants }
